<div class="table-responsive" *ngIf="!isHandheld">
  <ft-visual-hint></ft-visual-hint>
  <ag-grid-angular
    stickyHeader
    #ratingsGrid
    style="width: 100%; height: 100%"
    class="ag-theme-frk"
    [rowData]="sortedTableRows"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [frameworkComponents]="frameworkComponents"
    paginationPageSize="25"
    [pagination]="true"
    [suppressPaginationPanel]="true"
    domLayout="autoHeight"
    [isExternalFilterPresent]="isExternalFilterPresent"
    [doesExternalFilterPass]="doesExternalFilterPass"
    [context]="gridContext"
    [suppressCellSelection]="false"
    [ensureDomOrder]="true"
    (sortChanged)="onSortChanged()"
    rowHeight="83"
    [suppressRowTransform]="true"
    overlayNoRowsTemplate="<p></p>"
    [enableCellTextSelection]="true"
    (cellKeyDown)="setAccessibility($event)"
    (gridReady)="onGridReady()"
  >
  </ag-grid-angular>
</div>

<ft-ppss-card-container
  *ngIf="isHandheld"
  [rowData]="currentPage"
  [columnDefs]="columnDefs"
  [gridContext]="gridContext"
  [isSiteIntl]="isSiteIntl"
></ft-ppss-card-container>

<!-- Notification for empty rows -->
<ng-container *ngIf="numberofFilteredData === 0 && isPopulated">
  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <p class="bold large">
          {{ "products.fund-listing-no-search-result-message" | translate }}
        </p>
      </div>
    </div>
  </div>
</ng-container>
